import { h, ComponentChildren } from "preact";

import classname from "../../../foundation/utils/classname";
import { stopPropagation } from "../../../foundation/utils/legacy";
import FilterInput from "../Input/FilterInput";

import styles from "./FilterBar.module.css";

interface Props {
    class?: string;
    filterValue: string;
    leftContent?: ComponentChildren;
    rightContent?: ComponentChildren;
    filterInputClass?: string;
    filterInputPlaceholder?: string;
    filterInputDisabled?: boolean;
    onFilter: (value: string) => void;
}

function FilterBar({
    class: cssClass,
    filterValue = "",
    leftContent,
    rightContent,
    filterInputClass,
    filterInputPlaceholder,
    filterInputDisabled = false,
    onFilter
}: Props) {
    return (
        <div class={classname(styles.filterBar, cssClass)}>
            {leftContent && (
                <div class={styles.leftContent}>
                    {leftContent}
                </div>
            )}
            <FilterInput
                class={filterInputClass}
                value={filterValue}
                placeholder={filterInputPlaceholder}
                disabled={filterInputDisabled}
                onFilter={onFilter}
                onMouseDown={stopPropagation}/>
            {rightContent && (
                <div class={styles.rightContent}>
                    {rightContent}
                </div>
            )}
        </div>
    );
}

export default FilterBar;
